import { Injectable } from '@angular/core';
import { DialogService } from '../services/dialogs/dialog.service';

@Injectable()
export class ChangeRoleService {
  readonly strings = tiStrings.session.changeUserRoleService;

  constructor(public dialogService: DialogService) {}

  changeUserRoleShowModal(): void {
    this.dialogService.askQuestion(
      this.strings.title,
      this.strings.text,
      [
        {
          text: tiStrings.app.misc.ok,
          closeAction: true,
          primary: true,
          value: 'ok',
        },
      ],
      'Change-User-Role-For-CRA-Action',
      'fa fa-exclamation-triangle',
      true,
    );
  }
}
